// extracted by mini-css-extract-plugin
export default {"login":"Drafts_login__2pDoE","loginWrapper":"Drafts_loginWrapper__I+UQB"};